import {
  SET_INITIAL_SEARCH_PARAMS,
  SET_INITIAL_SEARCH_PARAM_DATES,
} from '../helpers/constants/actionsConstants';

import type { InitialSearchParamsAction } from '../actions/types';
import type { InitialSearchParamsState } from '../selectors/types';

const initialState: InitialSearchParamsState = {
  originId: '',
  destinationId: '',
  destinationName: '',
  outboundMonth: 0,
  outboundYear: 0,
};

const reducer = (
  state: InitialSearchParamsState = initialState,
  action: InitialSearchParamsAction,
): InitialSearchParamsState => {
  switch (action.type) {
    case SET_INITIAL_SEARCH_PARAMS:
      return {
        ...state,
        ...action.payload,
      };

    case SET_INITIAL_SEARCH_PARAM_DATES: {
      if (state.outboundMonth && state.outboundYear) {
        return state;
      }

      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
